import React from "react";
import Hero from "../components/Hero";
import FeaturedCoins from "../components/FeaturedCoins";
import AboutPreview from "../components/AboutPreview";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import Newsletter from "../components/Newsletter";

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <Hero />

      {/* Featured Coins Section */}
      <FeaturedCoins />

      {/* About Preview Section */}
      <AboutPreview />

      {/* Why Choose Us Section */}
      <WhyChooseUs />

     

      {/* Newsletter Section */}
      <Newsletter />
    </>
  );
};

export default Home;